import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import AniLink from "gatsby-plugin-transition-link/AniLink"

const Offers = ({ page = false }) => {
  const data = useStaticQuery(graphql`
    query OfferQuery {
      allContentfulOferta(sort: {order_number: ASC}) {
        nodes {
          title
          slug
          content {
            raw
          }
          shortDesc {
            internal {
              content
            }
          }
          image {
            gatsbyImageData(width: 1080)
          }
        }
      }
      allContentfulOfertaOpis {
        nodes {
          title
          text {
            internal {
              content
            }
          }
        }
      }
    }
  `)

  const Image = ({ data }) => {
    if (!data?.image?.gatsbyImageData) {
      return <div>Picture not found</div>
    }

    return <GatsbyImage image={{ ...data?.image?.gatsbyImageData, aspectRatio: 10 / 11 }} alt={''} />
  }

  const OfferItem = ({ data }) => {
    return (
      <AniLink fade to={data?.slug} state={{
        wtf: true
      }} className="offer-preview-item">
        <div className="offer-preview-image">
          <Image data={data} />
        </div>
        <div className="offer-preview-content">
          <h4>{data?.title}</h4>
          <p>{data?.shortDesc?.internal?.content}</p>
        </div>
      </AniLink>
    )
  }

  const offerSectionData = data?.allContentfulOfertaOpis?.nodes[0]

  return (
    <div id="oferta" className="section offer-section">
      <div className="section-pre-content">
        <h2 className="section-title">
          {offerSectionData?.title}
        </h2>
        <p>
          {offerSectionData?.text?.internal?.content}
        </p>
      </div>
      <div className="offer-preview-items">
        {data?.allContentfulOferta?.nodes?.map((offerData) => <OfferItem key={offerData.slug} data={offerData} />)}
      </div>
    </div>
  )
}

Offers.propTypes = {}

Offers.defaultProps = {}

export default Offers
